export type SiteConfig = typeof siteConfig;

export const siteConfig = {
    name: 'Bias Lens',
    description:
        'Bias Lens is a tool that helps you identify bias in your text.',
    mainNav: [
        {
            title: 'Home',
            href: '/',
        },
        {
            title: 'AI Assistant',
            href: '/ai-assistant',
        },
        {
            title: 'About',
            href: '/about',
        },
    ],
    links: {
        github: 'https://bhavaniit24.github.io/bias-detection-app',
        googleDrive:
            'https://drive.google.com/drive/folders/1o4Nd2JnJq7dPcB9hZiT97xZZs1Mfyj7M?usp=sharing',
        pypi: 'https://pypi.org/project/bias-lens',
        researchPaper:
            'https://drive.google.com/file/d/1TxGik_TRw7Oe79Lwh5NBICA3mfOGNoRG/view?usp=drive_link',
        reviewPaper:
            'https://drive.google.com/file/d/1DOXLIwpzRz6IfxxPrQz_kcNv4msGbgoL/view?usp=drive_link',
        medium: 'https://medium.com/@loganthan.20201212/introducing-bias-lens-a-powerful-python-library-for-bias-detection-and-explainable-ai-in-nlp-aaad01d22e1c',
    },
    implementation: {
        images: [
            {
                src: '/content/architecture-diagram.png',
                alt: 'Architecture Diagram',
            },
            {
                src: '/content/techstack-diagram.png',
                alt: 'Tech Stack Diagram',
            },
        ],
    },
};
